var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelHoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "#00725D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42222 5L7.45586 2.96635C7.51471 2.9075 7.51471 2.81219 7.45586 2.75334L7.24666 2.54414C7.18781 2.48529 7.0925 2.48529 7.03365 2.54414L5 4.57779L2.96635 2.54414C2.9075 2.48529 2.81219 2.48529 2.75334 2.54414L2.54414 2.75334C2.48529 2.81219 2.48529 2.9075 2.54414 2.96635L4.57779 5L2.54414 7.03365C2.48529 7.0925 2.48529 7.18781 2.54414 7.24666L2.75334 7.45586C2.81219 7.51471 2.9075 7.51471 2.96635 7.45586L5 5.42222L7.03365 7.45586C7.0925 7.51471 7.18781 7.51471 7.24666 7.45586L7.45586 7.24666C7.51471 7.18781 7.51471 7.0925 7.45586 7.03365L5.42222 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelHoverIcon);
export default __webpack_public_path__ + "static/media/CancelHoverIcon.9c1a04a49fb111d25bd2a36811bd97b5.svg";
export { ForwardRef as ReactComponent };